import React, { useCallback } from 'react'
import { PauseOutlineIcon } from '@/atoms/Icons/PauseOutlineIcon'
import { PlayOutlineIcon } from '@/atoms/Icons/PlayOutlineIcon'
import { useHlsPlayerUI } from './HlsPlayerUIContext'

/**
 * Small play/pause toggle button for the control bar.
 * Uses outline (stroked) icons for a lighter visual weight in the control bar.
 */
export const HlsPlayPauseButton: React.FC = () => {
  const { playing, controller } = useHlsPlayerUI()

  const handleClick = useCallback(() => {
    if (!controller) return
    if (playing) {
      controller.pause()
    } else {
      controller.play()
    }
  }, [controller, playing])

  return (
    <button
      type="button"
      className="flex h-8 w-8 items-center justify-center rounded-full text-white transition-colors hover:bg-white/20"
      onClick={handleClick}
      aria-label={playing ? 'Pause' : 'Play'}
    >
      {playing ? (
        <PauseOutlineIcon size={20} color="core-gray-100" />
      ) : (
        <PlayOutlineIcon size={22} color="core-gray-100" />
      )}
    </button>
  )
}
